import { z } from "zod";
import { UserRole, InviteCodeStatus } from "@carry/shared";
import { PublicIdSchema, PaginationRequest, PaginationResponse } from "./common";
import { User } from "./user";

export const InviteCodeSchema = z.string().regex(/^[A-Z0-9]{8}$/);

/** 新規招待 + 仮 user 作成 */
export const CreateInviteInput = z.object({
  name: z.string().min(1).max(100),
  role: UserRole,
  phone: z.string().max(20).optional().nullable(),
  /** default 24 */
  ttlHours: z.coerce.number().int().min(1).max(168).optional(),
});
export type CreateInviteInputDto = z.infer<typeof CreateInviteInput>;

export const CreatedInvite = z.object({
  user: User,
  code: InviteCodeSchema,
  expires_at: z.iso.datetime({ offset: true }),
});
export type CreatedInviteDto = z.infer<typeof CreatedInvite>;

/** 招待コード一覧取得の入力 */
export const ListInvitesInput = PaginationRequest.extend({
  status: InviteCodeStatus.optional(),
});
export type ListInvitesInputDto = z.infer<typeof ListInvitesInput>;

/** 招待コード一覧の各行 */
export const InviteListItem = z.object({
  public_id: PublicIdSchema,
  code: InviteCodeSchema,
  status: InviteCodeStatus,
  expires_at: z.iso.datetime({ offset: true }),
  used_at: z.iso.datetime({ offset: true }).nullable(),
  created_at: z.iso.datetime({ offset: true }),
  user: User,
});
export type InviteListItemDto = z.infer<typeof InviteListItem>;

export const ListInvitesOutput = z.object({
  data: z.array(InviteListItem),
  pagination: PaginationResponse,
});

/** 再発行: 対象ユーザーの既存 active は revoke して新コードを発行 */
export const ReissueInviteInput = z.object({
  user_public_id: PublicIdSchema,
  ttlHours: z.coerce.number().int().min(1).max(168).optional(),
});
export type ReissueInviteInputDto = z.infer<typeof ReissueInviteInput>;

/** 取消 */
export const RevokeInviteInput = z.object({
  public_id: PublicIdSchema,
});
export type RevokeInviteInputDto = z.infer<typeof RevokeInviteInput>;
